import React from 'react';
import { WagmiProvider } from 'wagmi';
import { config } from './wagmi';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import '@rainbow-me/rainbowkit/styles.css';
import { ConfigProvider } from 'antd';
import { antdTheme } from './config/antdConfig';
import { bsc } from 'wagmi/chains';
import Layout from './layout';
import Home from './pages/home';
import SoulPoint from './pages/soul';

// 创建React Query客户端
const client = new QueryClient();

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <WagmiProvider config={config}>
        <QueryClientProvider client={client}>
          <RainbowKitProvider initialChain={bsc}>
            <BrowserRouter>
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/soul" element={<SoulPoint />} />
                </Routes>
              </Layout>
            </BrowserRouter>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </ConfigProvider>
  );
}

export default App;
